import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';

const CategoryPills = ({ categories, active }) => {
  return (
    <div className="flex items-center gap-2 overflow-x-auto no-scrollbar py-2">
      {categories.map((c) => {
        const Icon = Icons[c.icon] || Icons.Sparkles;
        const isActive = active === c.id;
        const to = c.id === 'all' ? '/browse' : `/browse/${c.id}`;
        return (
          <Link key={c.id} to={to}
            className={`flex items-center gap-2 shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all border ${
              isActive
                ? 'bg-[#8247E5] text-white border-[#8247E5] shadow-sm'
                : 'bg-white text-neutral-700 border-neutral-200 hover:border-[#8247E5] hover:text-[#8247E5]'
            }`}>
            <Icon className="w-4 h-4" />
            {c.name}
          </Link>
        );
      })}
    </div>
  );
};

export default CategoryPills;
